import { createFileRoute, useNavigate } from '@tanstack/react-router'
import type { ReactElement } from 'react'

import { OrgDetailLayout } from '~/features/organizations'

/**
 * `/admin/organizations/$orgId` — Organization detail surface.
 *
 * Reads the `:orgId` path param via TanStack Router's typed `useParams`
 * (provided by the auto-generated `Route.useParams()`), then mounts the
 * 6-tab `OrgDetailLayout` (Overview / Subscription / Invoices / Storage /
 * Activity / Members).
 *
 * Back navigation jumps to the list route — the layout itself owns the
 * tab state and per-tab data fetching.
 */
export const Route = createFileRoute('/admin/organizations/$orgId')({
  component: OrganizationDetailRoute,
})

function OrganizationDetailRoute(): ReactElement {
  const { orgId } = Route.useParams()
  const navigate = useNavigate()
  return (
    <OrgDetailLayout
      orgId={orgId}
      onBack={() => navigate({ to: '/admin/organizations' })}
    />
  )
}
